import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute, ParamMap } from "@angular/router";
import {ApiService} from '../../services/api.service';
@Component({
  selector: 'app-nav-bar',
  templateUrl: './nav-bar.component.html',
  styleUrls: ['./nav-bar.component.css']
})
export class NavBarComponent implements OnInit {

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    public addVideoService: ApiService
  ) { 

  }

  ngOnInit(): void {
  }
  logout(){
    var obj = {
      userId:localStorage.getItem("userID")
    }
    this.addVideoService.logout(obj).subscribe((data) => {
      localStorage.clear();
      this.router.navigate(['']);

    });
  }

}
